import { inject } from "@angular/core";
import { ResolveFn } from "@angular/router";
import { of, tap } from "rxjs";
import { ApiClientService } from "~app/common/services/api-client.service";
import { ObjectUtils } from "~app/common/utils/object-utils";
import { DokumentUrlDTO } from "~app/pages/dokument/model/DokumentUrlDTO";

export const dokumentArbetsorderIdResolver: ResolveFn<DokumentUrlDTO> = (route, _state) => {
    const apiClientService = inject(ApiClientService);
    const dokumentId = route.paramMap.get("dokumentId");

    if(!dokumentId) {
        return of(null);
    }

    return apiClientService.get<DokumentUrlDTO>(`/arbetsorder/dokument/${dokumentId}`).pipe(
        tap<DokumentUrlDTO>(dokumentDto => {
            if(ObjectUtils.hasValue(dokumentDto?.url)) {
                window.location.href = dokumentDto.url;
            }
            return dokumentDto;
        })
    );
};
